module.exports = "/_next/static/images/DataScienceModeling@2x-68fd48a7f8345d48230b31448eb6c397.webp";